import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PersonalizedTitleApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = PersonalizedTitleApiClient;
export const PersonalizedTitleExtension = createModuleExtension({
  extensionName: 'personalizedTitleExtension',
  Provider,
  SDK: {
    personalizedTitleApiClient: client
  }
});
//# sourceMappingURL=personalized-title.extension.js.map